import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=f4050bd6&scoped=true&"
import script from "./ProductThumbnail.vue?vue&type=script&lang=js&"
export * from "./ProductThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4050bd6",
  null
  
)

export default component.exports